<template>
  <div class="row h-100 no-gutters">
    <div class="auth-form mx-auto my-auto col-md-5 col-lg-3">
      <div class="card">
        <div class="card-body">
          <h1 style="text-align: center">
            <img
              id="main-logo"
              class="d-inline-block align-top mr-1"
              style="max-width: 100px;"
              src="@/assets/images/headwear.jpg"
              alt="" />
          </h1>
          <d-alert
            v-if="authError"
            theme="danger"
            show>
            {{ $t('login.authError') }}
          </d-alert>
          <form @submit="login">
            <div class="form-group">
              <label>{{ $t('ui.emailAddress') }}</label>
              <d-input
                v-model="email"
                name="email"
                type="email"
                tabindex="1"
                @input="clearError('email')"
                :class="{'is-invalid' : larErrors.has('email')}"
                :placeholder="$t('login.emailPlaceholder')" />
              <div class="invalid-feedback" v-text="larErrors.get('email')"></div>
            </div>
            <div class="form-group">
              <label class="d-flex">
                <span>
                  {{ $t('login.password') }}
                </span>
                <a
                  href="/reset-hasla"
                  class="ml-auto"
                  tabindex="5">
                  {{ $t('login.resetPassword') }}
                </a>
              </label>
              <d-input
                v-model="password"
                name="password"
                type="password"
                tabindex="2"
                autocomplete="off"
                @input="clearError('password')"
                :class="{'is-invalid' : larErrors.has('password')}"
                :placeholder="$t('login.passwordPlaceholder')" />
              <div class="invalid-feedback" v-text="larErrors.get('password')"></div>
            </div>
            <button
              type="submit"
              tabindex="3"
              class="btn btn-pill btn-accent d-table mx-auto"
              @click.prevent="login"
              :disabled="submitting">
              <template v-if="!submitting">{{ $t('login.loginLabel') }}</template>
              <template v-else>{{ $t('login.loginInProgress') }}</template>
            </button>
          </form>
        </div>

        <div
          class="card-footer text-center"
          tabindex="4"
          style="background: rgba(90, 97, 105, .06);">
          <a href="/rejestracja">
            {{ $t('login.register') }}
          </a>
        </div>
      </div>

      <lang-switcher />
    </div>
  </div>
</template>

<script>
import LarErrors from '../utils/Errors';
import LangSwitcher from '../components/common/LangSwitcher.vue';

export default {
  name: 'Login',
  components: {
    LarErrors,
    'lang-switcher': LangSwitcher
  },
  data () {
    return {
      authError: false,
      submitting: false,
      larErrors: LarErrors,
      email: '',
      password: '',
    }
  },
  methods: {
    clearError () {
      this.authError = false;
    },
    login () {
      this.clearError();
      this.submitting = true;
      this.$http.post('/auth/login?lang=' + this.$i18n.locale, {
        email: this.email,
        password: this.password,
        panel: 'customer-panel'
      }).then((response) => {
        this.submitting = false;

        if (
          response.data &&
          response.data.success &&
          response.data.user.type === 'customer' &&
          response.data.user.permissions.partner_customers
        ) {
          window.localStorage.setItem('token', response.data.token);
          this.$http.defaults.headers.Authorization = `Bearer ${response.data.token}`;
          this.$store.commit('setCustomerID', response.data.user.customer_id);
          this.$store.commit('setParentID', response.data.user.parent_id);
          this.$store.commit('setUserID', response.data.user.id);
          this.$store.commit('setUserName', response.data.user.name);
          this.$store.commit('setUserEmail', response.data.user.email);
          this.$store.commit('setUserPermissions', response.data.user.permissions);
          this.$store.commit('setUserType', response.data.user.type);
          this.$store.commit('setUserLang', response.data.user.language_id);
          this.$store.commit('setUserLangCode', response.data.user.language_code.toLocaleLowerCase());

          this.$nextTick(() => {
            if (response.data.user.permissions.home) {
              this.$router.push('/kokpit');
            } else {
              this.$router.push('/zamowienia');
            }

            let languageCode = 'pl';

            if (response.data.user.language_code) {
              languageCode = response.data.user.language_code.toLocaleLowerCase();
            }

            if (languageCode && this.$i18n.locale !== languageCode) {
              window.localStorage.setItem('headwear-crm-ui-language', response.data.user.language_code.replace(/[^a-z]/gmi, ''));
              window.location.reload();
            }
          });
        } else {
          this.$router.push('/wyloguj');
        }
      }).catch((error) => {
        console.log(error);
        this.submitting = false;
        this.authError = true;
      });
    }
  }
}
</script>

<style scoped>

</style>
